import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { GridItemComponentSchema, GridItemPlacementSchema } from '../shared';

export const AccordionItemSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.AccordionItem),
  headline: z.string(),
  headingLevel: z
    .union([z.literal('h3'), z.literal('h4')])
    .nullish()
    .transform((x) => x ?? 'h3'),
  contents: z
    .object({
      gridItems: z
        .array(
          z.object({
            componentType: z.union([z.literal('dynamic'), z.literal('portableText')]).nullish(),
            component: GridItemComponentSchema,
            placements: z.array(GridItemPlacementSchema.extend({ grid: z.string() }))
          })
        )
        .nullish()
    })
    .nullish()
});

export type AccordionItem = z.infer<typeof AccordionItemSchema>;
